// routes
export const MEASUREMENT_SETTINGS = '/workflow/measurement-settings'
export const MEASUREMENT_SETTINGS_GET =
  '/workflow/measurement-settings/division/:companyDivisionUuid/measurement/:measurementUuid'
export const MEASUREMENT_SETTINGS_GET_PATCH_DELETE =
  '/workflow/measurement-settings/:measurementSettingsUuid'
export const MEASUREMENT_SETTINGS_POST = MEASUREMENT_SETTINGS

// messages
export const MEASUREMENT_RULES_MANAGMENT_UPDATE_MESSAGE =
  'Measurement rule has been successfully saved!'
export const MEASUREMENT_RULES_MANAGMENT_RESETE_MESSAGE =
  'Do you want to reset the customization of measurement rules? Measurement rules will be set to the default settings - {:divisionName}'
export const MEASUREMENT_RULES_CUSTOM_LEGEND =
  'Custom measurement configuration'
export const MEASUREMENT_RULES_INHERIT_LEGEND =
  'Inherited measurement configuration from the parent division'
